
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  EditOutlined,
  EyeOutlined,
  DeleteOutlined,
  SearchOutlined
} from "@ant-design/icons";
import icon from "../../../assets/static/images/secciones/abogados.png";
import { Button as ButtonAntd, Tabs } from "antd";
const { TabPane } = Tabs;
import { Button } from "react-bootstrap";

// import { Tabla } from "../../../components/Table/Table";
import { getAbogados } from "../../../redux/Sections/Abogados/actions";

// import AbogadosTable from "../../../components/FilterTable/AbogadosTable";
import { NewAbogado } from "./Abogado/NewAbogado";

import { Tabla } from "../../../components/Table/Table";
import { useRef } from "react";
import Swal from "sweetalert2";
import { AbogadoService } from "../../../_services/abogados.service";
import ShowAbogado from "./Abogado/ShowAbogado";
import ReactSelect from "react-select";
import Abogado from "../../../components/Abogado/Abogado";
import { v4 as uuidv4 } from "uuid";
import { useUser } from "../../../hooks/useUser";
import DescargarExcel from "../../../components/DescargarExcel/DescargarExcel";
import "./Abogados.css";
import ArrowBack from "../../../components/ArrowBack";

const Abogados = ({ dataList, getAbogados }) => {
  const user = useUser();

  const [titulos, setTitulos] = useState([]);
  const [abogado, setAbogado] = useState("");

  useEffect(() => {
    getAbogados();
  }, []);

  useEffect(() => {
    if (dataList?.length) {
      let data = dataList.find(e => e?.nrodni === +user?.dni);
      setAbogado(data);
    }
  }, [dataList]);

  useEffect(() => {
    const fetchTitulos = async () => {
      try {
        let data = await AbogadoService.getTitulos();
        setTitulos(data);
      }
      catch (err) {
        console.log(err);
      }
    };

    fetchTitulos();
  }, []);

  const [searchText, setSearchText] = useState();
  const [searchedColumn, setSearchedColumn] = useState();
  const [data, setData] = useState([]);


  const [verAbogado, setVerAbogado] = useState({
    show: false,
    data: {},
    key: "",
  });

  const [editAbogado, setEditAbogado] = useState({
    show: false,
    data: {},
    key: "",
  });


  useEffect(() => {
    if (dataList?.length) {
      let result = formatData(dataList)?.filter(e => {
        if (searchedColumn && e[searchedColumn]) {
          let result = e[searchedColumn]
            ?.toString()
            ?.toLowerCase()
            ?.includes(searchText?.toLowerCase());

          return result;
        }

        else {
          return true;
        }
      });

      setData(result);
    }
    else {
      setData([]);
    }


  }, [dataList, searchText]);



  useEffect(() => {
    if (verAbogado.show) {
      showAbogadoRef.current?.focus();
    }
    if (editAbogado.show) {
      showAbogadoRef.current?.focus();
    }
  }, [verAbogado, editAbogado]);

  let showAbogadoRef = useRef();

  const handleShow = (row) => {
    if (verAbogado.show && row.nrodni === verAbogado.key) {
      return setVerAbogado({ show: false, data: null, key: "", });
    }
    setEditAbogado({ show: false, data: null, key: "", });

    setVerAbogado({
      show: true,
      data: row,
      key: row.nrodni
    });
  };

  const handleEdit = (row) => {
    if (editAbogado.show && row.key === editAbogado.key) {
      return setEditAbogado({ show: false, data: null, key: "", });
    }
    setVerAbogado({ show: false, data: null, key: "", });

    setEditAbogado({
      show: true,
      data: row,
      key: row.nrodni
    });
  };

  const handleDelete = async (nrodni) => {
    if (nrodni) {
      Swal.fire({
        title: "¿Esta seguro de eliminar este abogado?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "No",
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si",
        reverseButtons: true,
      }).then(async (result) => {
        if (result.isConfirmed) {
          let response = await AbogadoService.deleteAbogado({ nrodni });
          if (response.status === 200) {
            getAbogados();
            Swal.fire(
              "Exito!",
              "Se elimino correctamente.",
              "success"
            );
          }
          else {
            getAbogados();
            Swal.fire(
              "Error!",
              "Ocurrio un error, intentelo nuevamente.",
              "error"
            );
          }
        }
      });
    }
  };


  const columns = [
    {
      title: "Apellido y Nombre",
      dataIndex: "apellido_nombre",
      width: "30%",
    },
    {
      title: "DNI",
      dataIndex: "nrodni",
      key: "nrodni",
    },
    {
      title: "Codexterno",
      dataIndex: "codexterno",
      key: "codexterno",
    },
    {
      title: "Matricula",
      dataIndex: "matricula",
      key: "matricula",
    },
    {
      title: "Baja",
      dataIndex: "baja",
      key: "baja",
    },
    {
      title: "Acciones",
      dataIndex: "acciones",
      render: (text, row) => {
        return <div className="d-flex justify-content-around">
          <Button
            className="d-flex align-items-center ml-2"
            variant="contained"
            style={{
              color: `${(verAbogado.show && row.nrodni === verAbogado.key) ? "#1890ff" : "#000000d9"}`,
              borderColor: `${(verAbogado.show && row.nrodni === verAbogado.key) ? "#1890ff" : "#d9d9d9"}`
            }}
            onClick={() => handleShow(row)}
          >
            <EyeOutlined
              style={{
                color: `${(verAbogado.show && row.nrodni === verAbogado.key) ? "#1890ff" : "#000000d9"}`,
              }}
            />
          </Button>
          {user && user.rol === "admin" ? (
            <>
              <Button
                className="d-flex align-items-center ml-2"
                variant="contained"
                style={{
                  color: `${(editAbogado.show && row.nrodni === editAbogado.key) ? "#1890ff" : "#000000d9"}`,
                  borderColor: `${(editAbogado.show && row.nrodni === editAbogado.key) ? "#1890ff" : "#d9d9d9"}`
                }}
                onClick={() => handleEdit(row)}
              >
                <EditOutlined />
              </Button>
              <Button
                className="d-flex align-items-center ml-2"
                variant="contained"
                onClick={() => handleDelete(row.nrodni)}
              >
                <DeleteOutlined style={{ color: "red" }} />
              </Button>
            </>
          ) : null}
        </div>;
      }
    },
  ];

  // Search
  const handleFilter = (e) => {
    if (e) {
      setSearchedColumn(e.value);
    } else {
      setSearchedColumn("");
    }
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  let options = [
    {
      label: "Seleccionar",
      value: "",
    },
    {
      label: "Apellido y Nombre",
      value: "apellido_nombre",
    },
    {
      label: "DNI",
      value: "nrodni",
    },
    {
      label: "Codexterno",
      value: "codexterno",
    },
    {
      label: "Matricula",
      value: "matricula",
    },
    {
      label: "Baja",
      value: "baja",
    },
  ];

  const formatData = (arrayData) => {
    try {
      return arrayData.map(item => {
        const { baja, apellido, nombre } = item;

        return {
          ...item,
          apellido_nombre: `${apellido?.toUpperCase()}, ${nombre}`,
          baja: baja ? "SI" : "NO",
          uuid: uuidv4(),
        };
      });
    }
    catch (err) {
      console.log(err);
      return [];
    }
  };


  function exportData(list) {
    let filename = "abogados.xlsx";

    const dataList = list.map((e) => {
      return {
        "APELLIDO Y NOMBRE": `${e.apellido?.toUpperCase()}, ${e.nombre}`,
        "DNI": e.nrodni,
        "DIRECCIÓN": e.direccion,
        "TELEFONO": e.te,
        "EMAIL": e.email,
        "MATRICULA": e.matricula,
        "CUIT - CUIL": e.cuitcuil,
        "TITULO": e.abo_titulo?.titulo,
        "BAJA": e.baja ? "SI" : "NO",
        "CODIGO EXTERNO": e.nrodni,
        "HORARIOS": e.horarios,
      };
    });

    let name = "Abogados";

    return {
      dataList,
      filename,
      name
    };
  }


  return (
    <div className="section-content">
      <div className="section-title d-flex align-items-center">
        <img src={icon} alt="abogados" />
        <span>Abogados</span>
      </div>
      <ArrowBack />

      <Tabs className="abogados-tabs" defaultActiveKey="1">
        <TabPane
          tab={
            <span className="tab-span">
              <span className="ml-2">Lista de abogados</span>
            </span>
          }
          key="1"
        >
          {dataList ? (
            <div className="">
              <div className="search">
                <ReactSelect
                  className="search-select"
                  options={options}
                  onChange={handleFilter}
                  styles={{
                    control: (styles) => ({
                      ...styles,
                      backgroundColor: "white",
                      border: "none",
                      borderColor: "none",
                      outline: "none",
                      boxShadow: "none !important",
                      height: "40px"
                    }),
                    indicatorSeparator: () => ({
                      backgroundColor: "white"
                    })
                  }}
                />

                <input onChange={handleSearch} value={searchText} />
                <div className="search-button">
                  <ButtonAntd>
                    <SearchOutlined />
                  </ButtonAntd>
                </div>
              </div>

              <Tabla columns={columns} dataList={data} getAbogados={getAbogados} />
              {editAbogado.show ? (
                <Abogado data={editAbogado.data} setEditAbogado={setEditAbogado} getAbogados={getAbogados} titulos={titulos} />
              ) : null}
              {verAbogado.show ? (
                <ShowAbogado data={verAbogado.data} setVerAbogado={setVerAbogado} titulos={titulos} />
              ) : null}
              <div ref={showAbogadoRef} tabIndex="1"></div>

              <div className="mt-3">
                <div style={{ maxWidth: 170 }}>
                  <DescargarExcel data={exportData(dataList)} />
                </div>
              </div>
            </div>
          ) : ""}
        </TabPane>
        <TabPane
          tab={
            <span className="tab-span">
              <span className="ml-2">Mis datos</span>
            </span>
          }
          key="2"
        >
          <Abogado data={abogado} getAbogados={getAbogados} titulos={titulos} />
        </TabPane>
        {user && user.rol === "admin" ? (
          <TabPane
            tab={
              <span className="tab-span">
                <span className="ml-2">Nuevo Profesional</span>
              </span>
            }
            key="3"
          >
            <NewAbogado getAbogados={getAbogados} titulos={titulos} />
          </TabPane>
        ) : null}
      </Tabs>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    dataList: state.dashboard.abogadosList,
    data: state.dashboard.abogado
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAbogados: () => dispatch(getAbogados()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Abogados);